import "../App.css"

const Header = () => {
    return (
        <div className="head-div">
        
        <h1>Knowledge Vault</h1>
        <hr />
        <p>
            This vault has a collection of all resources and content that I consume that helps me in self development. 
        </p>
        
      </div>
    )
}

export default Header
